(function(){
  // Licznik: odlicza od X godzin, pamięta czas po odświeżeniu, po zerze startuje od nowa
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]');
    var span=(parseInt(el.dataset.hours,10)||4)*3600000;
    var key='bz_cd_end_'+span, end=0;
    try{end=parseInt(localStorage.getItem(key),10)||0}catch(e){}
    function reset(){end=Date.now()+span;try{localStorage.setItem(key,String(end))}catch(e){}}
    if(!end||end<=Date.now()||end-Date.now()>span) reset();
    function tick(){
      var d=Math.floor((end-Date.now())/1000);
      if(d<=0){reset();d=Math.floor(span/1000);}
      h.textContent=String(Math.floor(d/3600)).padStart(2,'0');
      m.textContent=String(Math.floor(d%3600/60)).padStart(2,'0');
      s.textContent=String(d%60).padStart(2,'0');
    }
    tick();setInterval(tick,1000);
  });

  // Menu mobilne
  document.querySelectorAll('[data-burger]').forEach(function(b){
    b.addEventListener('click',function(){document.querySelector('[data-mnav]').classList.toggle('open')});
  });

  // Akordeony (produkt + FAQ)
  document.addEventListener('click',function(e){
    var h=e.target.closest('.acc-h');
    if(h) h.parentElement.classList.toggle('open');
  });

  // Karuzele
  document.querySelectorAll('[data-carousel]').forEach(function(c){
    var t=c.querySelector('.track');
    function step(){var f=t.firstElementChild;return f?f.offsetWidth+16:300}
    var p=c.querySelector('.c-prev'),n=c.querySelector('.c-next');
    if(p) p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'})});
    if(n) n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'})});
  });

  // "Pokaż więcej opinii"
  document.querySelectorAll('[data-reviews]').forEach(function(sec){
    var btn=sec.querySelector('[data-more]');if(!btn)return;
    var step=parseInt(sec.dataset.step,10)||4;
    btn.addEventListener('click',function(){
      var hidden=sec.querySelectorAll('.r-card[hidden]');
      for(var i=0;i<Math.min(step,hidden.length);i++) hidden[i].hidden=false;
      if(sec.querySelectorAll('.r-card[hidden]').length===0) btn.remove();
    });
  });

  // Sekcja produktu
  document.querySelectorAll('[data-product]').forEach(function(sec){
    var dataEl=sec.querySelector('[data-variants]');
    var variants=dataEl?JSON.parse(dataEl.textContent):[];
    var currency=sec.dataset.currency||'PLN';
    var fmt=new Intl.NumberFormat('pl-PL',{style:'currency',currency:currency});
    function money(c){return fmt.format(c/100)}
    function current(){
      var id=parseInt(sec.dataset.variant,10);
      for(var i=0;i<variants.length;i++) if(variants[i].id===id) return variants[i];
      return variants[0];
    }

    // Galeria: miniatury, strzałki, przesuwanie palcem
    var track=sec.querySelector('[data-gtrack]');
    var thumbs=sec.querySelectorAll('[data-thumb]');
    var cur=sec.querySelector('[data-gcur]');
    var slideIdx=0;
    function goTo(i,smooth){
      if(!track)return;
      var n=track.children.length;if(!n)return;
      i=(i+n)%n;
      track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'});
      setActive(i);
    }
    function setActive(i){
      slideIdx=i;
      thumbs.forEach(function(t,k){t.classList.toggle('active',k===i)});
      if(cur)cur.textContent=i+1;
      var a=thumbs[i];
      if(a&&a.parentElement.scrollWidth>a.parentElement.clientWidth){
        a.parentElement.scrollTo({left:a.offsetLeft-a.parentElement.clientWidth/2+a.offsetWidth/2,behavior:'smooth'});
      }
    }
    thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(parseInt(t.dataset.thumb,10))})});
    var gp=sec.querySelector('[data-gprev]'),gn=sec.querySelector('[data-gnext]');
    if(gp)gp.addEventListener('click',function(){goTo(slideIdx-1)});
    if(gn)gn.addEventListener('click',function(){goTo(slideIdx+1)});
    if(track){
      var st;
      track.addEventListener('scroll',function(){
        clearTimeout(st);
        st=setTimeout(function(){
          var i=Math.round(track.scrollLeft/track.clientWidth);
          if(i!==slideIdx)setActive(i);
        },60);
      },{passive:true});
      window.addEventListener('resize',function(){goTo(slideIdx,false)});
    }
    function goToMedia(id){
      if(!track)return;
      var slides=track.children;
      for(var k=0;k<slides.length;k++) if(String(slides[k].dataset.mediaId)===String(id)){goTo(k);return;}
    }

    // Ceny zestawów liczone z ceny wariantu
    function updatePrices(){
      var v=current();if(!v)return;
      sec.querySelectorAll('[data-bundle]').forEach(function(b){
        var qty=parseInt(b.dataset.qty,10)||1,disc=parseFloat(b.dataset.discount)||0;
        var pEl=b.querySelector('[data-price]'),cEl=b.querySelector('[data-compare]');
        if(pEl&&!b.dataset.priceOverride) pEl.textContent=money(Math.round(v.price*qty*(100-disc)/100));
        if(cEl&&!b.dataset.compareOverride){
          var base=(v.compare_at_price&&v.compare_at_price>v.price)?v.compare_at_price:v.price;
          var show=disc>0||(v.compare_at_price&&v.compare_at_price>v.price);
          cEl.textContent=show?money(base*qty):'';
        }
      });
    }

    // Wybór wariantu (np. rozmiaru) – przyciski S/M/L ustawiają rozmiar wszystkich sztuk (na stronie i na pasku)
    function setVariant(id){
      id=String(id);
      sec.dataset.variant=id;
      sec.querySelectorAll('[data-variant-btn]').forEach(function(x){x.classList.toggle('active',x.dataset.id===id)});
      sec.querySelectorAll('[data-item-variant]').forEach(function(sel){sel.value=id});
      var v=current();
      if(v&&v.featured_media) goToMedia(v.featured_media.id);
      updatePrices();
      updateSticky();
      syncStickySizes();
    }
    sec.querySelectorAll('[data-variant-btn]').forEach(function(b){
      b.addEventListener('click',function(){setVariant(b.dataset.id)});
    });
    // Zmiana rozmiaru #1/#2 w zestawie na stronie -> pasek
    sec.addEventListener('change',function(e){
      if(!e.target.matches('[data-item-variant]'))return;
      var b=e.target.closest('[data-bundle]');
      // zestaw 1 szt.: rozmiar z listy = wybrany wariant (cena, zdjęcie)
      if(b&&b.querySelectorAll('[data-item-variant]').length===1){setVariant(e.target.value);return}
      syncStickySizes();
    });

    // Wybór zestawu
    var bundles=sec.querySelectorAll('[data-bundle]');
    bundles.forEach(function(b){
      b.addEventListener('click',function(){
        bundles.forEach(function(x){x.classList.remove('active')});
        b.classList.add('active');
        buildStickySizes();
        updateSticky();
        updateGifts(true);
      });
    });
    if(bundles.length&&!sec.querySelector('[data-bundle].active')) bundles[0].classList.add('active');
    updatePrices();

    // Prezenty: zapalają się zależnie od liczby sztuk w wybranym zestawie
    function activeQty(){var b=sec.querySelector('[data-bundle].active');return b?parseInt(b.dataset.qty,10)||1:1}
    function updateGifts(anim){
      var q=activeQty(),all=true;
      sec.querySelectorAll('[data-gift]').forEach(function(g){
        var on=q>=(parseInt(g.dataset.min,10)||1),was=g.classList.contains('on');
        g.classList.toggle('on',on);
        if(on&&!was&&anim){g.classList.remove('pop');void g.offsetWidth;g.classList.add('pop')}
        if(!on)all=false;
      });
      sec.querySelectorAll('[data-gifts-hint]').forEach(function(h){
        h.textContent=all?h.dataset.done:h.dataset.locked;
        h.classList.toggle('done',all);
      });
    }
    function giftNames(){
      var q=activeQty(),n=[];
      sec.querySelectorAll('[data-gift]').forEach(function(g){
        if(g.dataset.note==='true'&&q>=(parseInt(g.dataset.min,10)||1))n.push(g.dataset.name);
      });
      return n;
    }
    updateGifts(false);

    // Dodaj do koszyka
    var btn=sec.querySelector('[data-atc]'),err=sec.querySelector('[data-atc-err]');
    if(btn) btn.addEventListener('click',function(){
      var id=parseInt(sec.dataset.variant,10);
      if(!id){if(err)err.textContent='Wybierz produkt w ustawieniach sekcji.';return;}
      var b=sec.querySelector('[data-bundle].active');
      var qty=b?parseInt(b.dataset.qty,10)||1:1;
      var mode=sec.dataset.after||'drawer';
      if(mode==='drawer'&&!(window.BZCart&&document.querySelector('[data-cart-drawer]'))) mode='cart';
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var label=btn.textContent;btn.disabled=true;btn.textContent='DODAJĘ...';if(err)err.textContent='';
      var items=[{id:id,quantity:qty}];
      var sels=b?b.querySelectorAll('[data-item-variant]'):[];
      if(sels.length){
        var map={},order=[];
        sels.forEach(function(sel){var v=sel.value;if(!map[v]){map[v]=0;order.push(v)}map[v]++});
        items=order.map(function(v){return {id:parseInt(v,10),quantity:map[v]}});
      }
      var chain=mode==='checkout'?fetch(root+'cart/clear.js',{method:'POST'}):Promise.resolve();
      chain.then(function(){
        return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
      }).then(function(r){
        if(!r.ok) return r.json().then(function(j){throw new Error(j.description||j.message||'Błąd')});
        if(sec.querySelector('[data-gift]')){
          return fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:{'Prezenty':giftNames().join(', ')}})}).catch(function(){});
        }
      }).then(function(){
        var sync=window.BZCart?BZCart.refresh():Promise.resolve();
        if(mode==='drawer'){
          return sync.then(function(){btn.disabled=false;btn.textContent=label;BZCart.open();});
        }
        return sync.then(function(){window.location.href=mode==='checkout'?root+'checkout':root+'cart';});
      }).catch(function(e){
        btn.disabled=false;btn.textContent=label;
        if(err) err.textContent=e.message||'Nie udało się dodać do koszyka.';
      });
    });

    // Przyklejony pasek kupna (telefon) – zestaw + rozmiar dla każdej sztuki, zsynchronizowane ze stroną
    var sticky=sec.querySelector('[data-sticky]');
    var sBundle=sticky&&sticky.querySelector('[data-sticky-bundle]');
    var sSizes=sticky&&sticky.querySelector('[data-sticky-sizes]');
    var sizeOn=!!(sticky&&sticky.dataset.sizes==='true'&&variants.length>1);
    var shown=false;
    function esc(t){return String(t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
    function activeBundle(){return sec.querySelector('[data-bundle].active')}
    function bundleTitle(b){var n=b.querySelector('.b-name');if(!n)return '';var t=n.childNodes[0];return (t&&t.nodeType===3?t.textContent:n.textContent).trim()}
    function bundlePrice(b){var p=b.querySelector('[data-price]');return p?p.textContent.trim():''}
    function buildStickySizes(){
      if(!sticky||!sSizes)return;
      if(!sizeOn){sSizes.hidden=true;sticky.classList.remove('has-size');return}
      var b=activeBundle(),items=b?b.querySelectorAll('[data-item-variant]'):[];
      var n=items.length||1,prefix=sticky.dataset.prefix?sticky.dataset.prefix+': ':'',html='';
      for(var i=0;i<n;i++){
        html+='<select data-sticky-size="'+i+'" aria-label="Rozmiar'+(n>1?' #'+(i+1):'')+'"'+(shown?'':' tabindex="-1"')+'>'+
          variants.map(function(v){return '<option value="'+v.id+'"'+(v.available?'':' disabled')+'>'+(n>1?'#'+(i+1)+': ':prefix)+esc(v.title)+'</option>'}).join('')+'</select>';
      }
      sSizes.innerHTML=html;sSizes.hidden=false;sticky.classList.add('has-size');
      syncStickySizes();
    }
    function syncStickySizes(){
      if(!sSizes||sSizes.hidden)return;
      var b=activeBundle(),items=b?b.querySelectorAll('[data-item-variant]'):[];
      sSizes.querySelectorAll('select').forEach(function(s,i){s.value=items.length&&items[i]?items[i].value:sec.dataset.variant});
    }
    function updateSticky(){
      if(!sticky)return;
      var b=activeBundle();
      var sp=sticky.querySelector('[data-sticky-price]');
      if(sp)sp.textContent=b?bundlePrice(b):'';
      if(sBundle&&bundles.length>1){
        sBundle.innerHTML=Array.prototype.map.call(bundles,function(x,i){return '<option value="'+i+'">'+esc(bundleTitle(x))+' • '+esc(bundlePrice(x))+'</option>'}).join('');
        sBundle.value=String(Array.prototype.indexOf.call(bundles,b));
        sBundle.hidden=false;sticky.classList.add('has-bundle');
        if(sp)sp.hidden=true;
      }
    }
    if(sticky){
      document.body.appendChild(sticky);
      var sb=sticky.querySelector('[data-sticky-btn]');
      sb.addEventListener('click',function(){if(btn)btn.click()});
      if(sBundle) sBundle.addEventListener('change',function(){var b=bundles[parseInt(sBundle.value,10)];if(b)b.click()});
      if(sSizes) sSizes.addEventListener('change',function(e){
        var s=e.target;if(!s.matches('[data-sticky-size]'))return;
        var b=activeBundle(),items=b?b.querySelectorAll('[data-item-variant]'):[];
        var i=parseInt(s.dataset.stickySize,10);
        if(items.length&&items[i]){items[i].value=s.value}
        else setVariant(s.value);
      });
      function checkSticky(){
        if(!btn)return;
        var show=btn.getBoundingClientRect().bottom<0;
        if(show===shown)return;
        shown=show;
        sticky.classList.toggle('show',show);
        sticky.setAttribute('aria-hidden',show?'false':'true');
        sticky.querySelectorAll('button,select').forEach(function(el){el.tabIndex=show?0:-1});
        document.body.classList.toggle('has-sticky',show);
      }
      window.addEventListener('scroll',checkSticky,{passive:true});
      window.addEventListener('resize',checkSticky);
      buildStickySizes();
      updateSticky();
      checkSticky();
    }

    // Licznik osób oglądających
    var vw=sec.querySelector('[data-viewers]');
    if(vw){
      var min=parseInt(vw.dataset.min,10)||15,max=parseInt(vw.dataset.max,10)||35;
      setInterval(function(){vw.textContent=min+Math.floor(Math.random()*(max-min+1))},6000);
    }
  });
})();
